// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";

type PropsType = {
  translate: string => void,
  history: Object
};

type StateType = {};

class ErrorPage extends Component<PropsType, StateType> {
  render() {
    const { translate, history } = this.props;
    return (
      <div className="layout-centered bg-gray error-page-height-fix">
        <main className="main-content text-center pb-lg-8 error-page-height-fix">
          <div className="container">
            <h1 className="display-1 text-muted mb-7">{translate("ErrorPagesLocale.title")}</h1>
            <p className="lead">{translate("ErrorPagesLocale.content")}</p>
            <br />
            <button
              className="btn btn-secondary w-250 mr-2"
              type="button"
              onClick={() => {
                history.goBack();
              }}
            >
              {translate("ErrorPagesLocale.goback")}
            </button>
            <Link to="/" className="btn btn-secondary w-250">
              {translate("ErrorPagesLocale.homepage")}
            </Link>
          </div>
        </main>
      </div>
    );
  }
}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/Components/ErrorPage/ErrorPage.js